import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { TimeFilter } from '../filters/TimeFilter';
import {
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import { debounce } from 'lodash';
import List from '@mui/material/List';
import { NumericFormat } from 'react-number-format';
import api from '../../../services/api';
import { formatNumber } from '../../../reducer/actions/formatNumber';

export const CustomFieldForAccommodationPrices: FieldComponent<any, any> = ({
  onChange,
  isActive,
  value,
  defaultValue,
  forcedValue,
  allValue,
  hasTooltip,
  disabled,
  column,
}) => {
  const [properties, setProperties] = useState<any>({});
  const [currentState, setCurrentState] = useState<any>({
    value: {},
    send: false,
  });
  const columns = useMemo(() => {
    const items = [];
    for (let i = 1; i < 51; i++) {
      items.push({
        name: i,
        column: `size_${i}`,
      });
    }

    return items;
  }, []);

  const handlePaste = (event: any, index: number) => {
    event.preventDefault();
    const paste = event.clipboardData.getData('text');
    const pastedValues = paste.split('\t').slice(0, 50);
    const pastedValuesWithKey: any = {};
    pastedValues.map((item: any, pastedValueIndex: any) => {
      let pastedPrice = item.replace(' ', '');

      if (pastedPrice.includes(',') && pastedPrice.includes('.')) {
        pastedPrice = pastedPrice.replace(',', '');
      } else if (pastedPrice.includes(',')) {
        pastedPrice = pastedPrice.replace(',', '.');
      }
      pastedValuesWithKey[`size_${index + pastedValueIndex + 1}`] = parseFloat(
        pastedPrice
      );
    });
    const tempState = { ...currentState.value };
    Object.keys(pastedValuesWithKey).map((item: any) => {
      tempState[`${item}`] = pastedValuesWithKey[`${item}`];
    });

    setCurrentState({
      value: tempState,
      send: true,
    });

    setProperties(tempState);
  };

  const fetchPrices = useCallback(() => {
    const searchParams = new URLSearchParams({});
    if (allValue?.id) {
      api
        .get(`/accommodation-prices/${allValue?.id}`, searchParams)
        .then((res: any) => {
          setProperties(res);
        });
    }
  }, [allValue]);

  useEffect(() => {
    fetchPrices();
  }, []);

  useEffect(() => {
    if (forcedValue) {
      const propTemp: any = {};
      for (let i = 1; i < 51; i++) {
        const price = parseFloat((forcedValue / i).toFixed(2));
        propTemp[`size_${i}`] = price;
      }

      setProperties(propTemp);
    }
  }, [forcedValue]);

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 500),
    []
  );

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);

  return (
    <>
      {properties ? (
        <>
          <List component="div" disablePadding>
            <ListItem
              sx={{
                padding: '0px',
              }}
            >
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {columns.map((item, index) => (
                        <TableCell
                          align={'center'}
                          sx={{
                            minWidth: '75px',
                            fontWeight: 'bold',
                            background: '#f1f1f1',
                          }}
                          key={index}
                        >
                          {item.name}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      {columns.map((item: any, index) => {
                        return (
                          <TableCell
                            key={index}
                            sx={{
                              padding: '0px',
                              borderRight: '1px solid #e3e3e3',
                            }}
                          >
                            <NumericFormat
                              className={
                                'w-full text-center min-w-[85px] py-[5px]'
                              }
                              value={
                                properties[item.column]
                                  ? properties[item.column]
                                  : null
                              }
                              thousandSeparator=" "
                              decimalScale={2}
                              fixedDecimalScale={true}
                              onChange={(event) => {
                                const value = formatNumber(
                                  event.target.value,
                                  true
                                );
                                setCurrentState({
                                  value: {
                                    ...currentState.value,
                                    [item.column]: value,
                                  },
                                  send: true,
                                });
                              }}
                              onPaste={(event: any) =>
                                handlePaste(event, index)
                              }
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </ListItem>
          </List>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

CustomFieldForAccommodationPrices.includes = (query, value) => true;

CustomFieldForAccommodationPrices.comparator = () => 0;

CustomFieldForAccommodationPrices.FilterRenderer = TimeFilter;
